export default ()=>{
  let groupID = parseInt(sessionStorage.getItem('groupID')),
    adminRoute=[
      {
        path: '/user',
        name: '用户管理',
        component: {render: (e) => e("router-view")},
        children:[
         /* {
            path: 'driver',
            name: '散户车辆',
            component: () => import('@/view/user/driver.vue')
          },*/
          {
            path: '/fleetDriver',
            name: '司机管理',
            component: () => import('@/view/user/fleetDriver.vue'),
          },
          {
            path: '/agent',
            name: '合伙人',
            component: () => import('@/view/agent/lists.vue'),
          },
          {
            path: 'user',
            name: '站点用户',
            component: () => import('@/view/user/supplier.vue')
          },
          /*{
            path: 'lists',
            name: '未绑定用户',
            component: () => import('@/view/user/lists.vue')
          },*/
        ],
      },
      {
        path: '/supplier',
        name: '站点管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'private',
            name: '柴油站点',
            component: () => import('@/view/gas/oilStation.vue')
          },
          {
            path: 'lng',
            name: 'LNG站点',
            component: () => import('@/view/gas/lngStation.vue')
          },
          {
            path: 'CFTStation',
            name: '车福通站点',
            component: () => import('@/view/gas/CFTStation.vue')
          },
          {
            path: 'UETStation',
            name: 'UET站点',
            component: () => import('@/view/gas/UETStation.vue')
          },
          {
            path: 'miaojiaStation',
            name: '秒加',
            component: () => import('@/view/gas/miaojiaStation.vue')
          },
          /*{
            path: 'oilStation',
            name: '油站列表',
            component: () => import('@/view/gas/oilStation.vue')
          },
          {
            path: 'tuanyou',
            name: '团油列表',
            component: () => import('@/view/gas/ty.vue')
          },*/
          {
            path: 'csh',
            name: '车生活站点',
            component: () => import('@/view/gas/station.vue')
          },
          {
            path: 'map',
            name: '站点地图',
            component: () => import('@/view/map/index.vue')
          },
          {
            path: 'routePlan',
            name: '线路规划',
            component: () => import('@/view/map/routePlan.vue')
          },
          {
            path: 'uploadStation',
            name: '站点导入',
            component: () => import('@/view/map/upload.vue')
          },
          {
            path: 'setPrice',
            name: '价格设置',
            component: () => import('@/view/gas/setPrice.vue')
          },
          {
            path: 'setNdrcPrice',
            name: '挂牌价设置',
            component: () => import('@/view/gas/setNdrcPrice.vue')
          },
          {
            path: 'stationCollect',
            name: '站点收集',
            component: () => import('@/view/station/stationCollect.vue')
          },
          {
            path: 'xindianStation',
            name: '充电站列表',
            component: () => import('@/view/gas/xindianStation.vue')
          },
          {
            path: 'lowPriceDuplicateStations',
            name: '低价重复站点',
            component: () => import('@/view/gas/lowPriceDuplicateStations.vue')
          }
        ],
      },
      {
        path: '/fleet',
        name: '车队管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'lists',
            name: '车队列表',
            component: () => import('@/view/fleet/lists.vue')
          },
          {
            path: 'companyStation',
            name: '车队定时改价',
            component: () => import('@/view/fleet/setPrice.vue')
          },
          {
            path: 'stationManage',
            name: '车队站点管理',
            component: () => import('@/view/fleet/stationManage.vue')
          },
          {
            path: 'card',
            name: '车队车辆',
            component: () => import('@/view/fleet/card.vue')
          },
          {
            path: 'zhongqi',
            name: '顺途',
            component: () => import('@/view/zhongqi/list.vue')
          },
          {
            path: 'uet',
            name: 'UET',
            component: () => import('@/view/zhongqi/uet.vue')
          },
        ],
      },
      {
        path: '/order',
        name: '订单管理',
        component:{render: (e) => e("router-view")},
        meta:{showAlways:true},
        children:[
          /*{
            path: 'private',
            name: '散户订单',
            component: () => import('@/view/order/lists.vue')
          },*/
          /*{
            path: 'waitPay',
            name: '待支付订单',
            component: () => import('@/view/order/waitPay.vue')
          },*/
          {
            path: 'companyOrder',
            name: '车队订单',
            component: () => import('@/view/order/companyOrder.vue')
          },
          {
            path: 'huituoOrder',
            name: '安能订单',
            component: () => import('@/view/order/huituoOrder.vue')
          },
          {
            path: 'feedback',
            name: '订单评价',
            component: () => import('@/view/feedback/index.vue')
          },
          {
            path: 'xindianOrder',
            name: '充电订单',
            component: () => import('@/view/order/chargingOrderList.vue')
          },
          {
            path: 'shellOrder',
            name: '壳牌虚拟卡订单',
            component: () => import('@/view/order/shellOrderLists.vue')
          },
          /*{
            path: 'promoteCount',
            name: '推广统计',
            component: () => import('@/view/promote/count.vue')
          },*/
          /*{
            path: 'private',
            name: '私油订单',
            component: () => import('@/view/order/lists2.vue')
          },*/
          /*{
            path: 'csh',
            name: '车生活订单',
            component: () => import('@/view/order/csh.vue')
          },*/
        ],
      },
      {
        path: '/finance',
        name: '财务管理',
        component: {render: (e) => e("router-view")},
        children: [
          /*{
            path: 'settle',
            name: '结账单',
            component: () => import('@/view/settlement/lists.vue')
          },*/
          {
            path: 'invoice',
            name: '订单开票',
            component: () => import('@/view/finance/invoice.vue')
          },
          {
            path: 'financeCount',
            name: '财务统计',
            component: () => import('@/view/finance/index.vue')
          },
          {
            path: 'financeCount',
            name: '站点财务统计',
            component: () => import('@/view/finance/stationCount.vue')
          },
            {
            path: 'balance',
            name: '渠道充值',
            component: () => import('@/view/finance/balance.vue')
          },
          {
            path: 'siteBalance',
            name: '站点充值',
            component: () => import('@/view/finance/siteBalance.vue')
          },
          {
            path: 'companyRechargeTotal',
            name: '车队充值汇总',
            component: () => import('@/view/finance/companyRechargeTotal.vue')
          },
          {
            path: 'verification',
            name: '车队充值核销',
            component: () => import('@/view/finance/verification.vue')
          },
          // {
          //   path: 'minshengNotice',
          //   name: '民生银行通知',
          //   component: () => import('@/view/finance/minshengNotice.vue')
          // },
          {
            path: 'xywithdraw',
            name: '小云提现',
            component: () => import('@/view/withdraw/xiaoyun.vue')
          },
          {
            path: 'balanceRebate',
            name: '返利',
            component: () => import('@/view/rebate/lists.vue')
          },
          {
            path: 'jiayouba',
            name: '驾油吧',
            component: () => import('@/view/finance/jiayouba/index.vue')
          },
          /*{
            path: 'commission',
            name: '佣金账户',
            component: () => import('@/view/asset/commission.vue')
          },
          {
            path: 'promote/record',
            name: '电话收入',
            component: () => import('@/view/promote/record.vue')
          },
          {
            path: 'promote/charge',
            name: '充值记录',
            component: () => import('@/view/promote/charge.vue')
          },
          {
            path: 'withdraw',
            name: '提现记录',
            component: () => import('@/view/withdraw')
          },*/
          /*{
            path: 'member',
            name: '会员充值',
            component: () => import('@/view/user/member.vue')
          },
          {
            path: 'asset/commission',
            name: '佣金账户',
            component: () => import('@/view/asset/commission.vue')
          },
          {
            path: 'asset/income',
            name: '私油账户',
            component: () => import('@/view/asset/income.vue')
          },
          {
            path: 'withdraw',
            name: '提现记录',
            component: () => import('@/view/withdraw')
          },
          {
            path: 'financeOrder',
            name: '财务订单',
            component: () => import('@/view/order/financeLists.vue')
          },*/
        ]
      },
      {
        path: '/operation',
        name: '运营管理',
        component: {render: (e) => e("router-view")},
        children: [
          // {
          //   path: 'qpcard',
          //   name: '壳牌卡',
          //   component: () => import('@/view/qpcard/index.vue')
          // },
          {
            path: 'shellCard',
            name: '壳牌虚拟卡',
            component: () => import('@/view/shell-card/lists.vue')
          },
          {
            path: 'sys',
            name: '系统配置',
            component: () => import('@/view/config/edit.vue')
          },
          {
            path: 'advert',
            name: '首页广告',
            component: () => import('@/view/advert/lists.vue')
          },
          {
            path: 'adminUser',
            name: '后台用户',
            component: () => import('@/view/system/user/user-lists.vue')
          },
          {
            path: 'lottery',
            name: '抽奖设置',
            component: () => import('@/view/lottery/item.vue')
          },
             {
            path: 'manual',
            name: '司机端手册配置',
            component: () => import('@/view/manual/list.vue')
          },
           {
            path: 'manual',
            name: '管理端手册配置',
            component: () => import('@/view/manual/index.vue')
          },
          /*{
            path: 'oilPrice',
            name: '油价设置',
            component: () => import('@/view/tuanyou/setPrice.vue')
          },*/
          {
            path: 'transfer',
            name: '转账管理',
            component: () => import('@/view/transfer/lists.vue')
          },
          {
            path: 'operationLog',
            name: '操作日志',
            component: () => import('@/view/system/log/operationLog.vue')
          },
        ]
      },
      {
        path:'/xyobd',
        name: '车辆诊断',
        // href: 'http://team.xyobd.com/kst/#/login?mobile=15928961336&password=wb201318&intoType=KST',
        href: 'http://team.xyobd.com/largeScreen/#/',
        component: {render: (e) => e("router-view")},
      },
    ],
    //运营
    yunyingRoute=[
      {
        path: '/user',
        name: '用户管理',
        component: {render: (e) => e("router-view")},
        children:[
          /* {
             path: 'driver',
             name: '散户车辆',
             component: () => import('@/view/user/driver.vue')
           },*/
          {
            path: '/fleetDriver',
            name: '司机管理',
            component: () => import('@/view/user/fleetDriver.vue'),
          },
          {
            path: '/agent',
            name: '合伙人',
            component: () => import('@/view/agent/lists.vue'),
          },
          {
            path: 'user',
            name: '站点用户',
            component: () => import('@/view/user/supplier.vue')
          },
          /*{
            path: 'lists',
            name: '未绑定用户',
            component: () => import('@/view/user/lists.vue')
          },*/
        ],
      },
      {
        path: '/supplier',
        name: '站点管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'private',
            name: '柴油站点',
            component: () => import('@/view/gas/oilStation.vue')
          },
          {
            path: 'lng',
            name: 'LNG站点',
            component: () => import('@/view/gas/lngStation.vue')
          },
          {
            path: 'CFTStation',
            name: '车福通站点',
            component: () => import('@/view/gas/CFTStation.vue')
          },
          {
            path: 'UETStation',
            name: 'UET站点',
            component: () => import('@/view/gas/UETStation.vue')
          },
          {
            path: 'miaojiaStation',
            name: '秒加',
            component: () => import('@/view/gas/miaojiaStation.vue')
          },
          /*{
            path: 'oilStation',
            name: '油站列表',
            component: () => import('@/view/gas/oilStation.vue')
          },
          {
            path: 'tuanyou',
            name: '团油列表',
            component: () => import('@/view/gas/ty.vue')
          },*/
          {
            path: 'csh',
            name: '车生活站点',
            component: () => import('@/view/gas/station.vue')
          },
          {
            path: 'map',
            name: '站点地图',
            component: () => import('@/view/map/index.vue')
          },
          {
            path: 'routePlan',
            name: '线路规划',
            component: () => import('@/view/map/routePlan.vue')
          },
          {
            path: 'uploadStation',
            name: '站点导入',
            component: () => import('@/view/map/upload.vue')
          },
          {
            path: 'setPrice',
            name: '价格设置',
            component: () => import('@/view/gas/setPrice.vue')
          },
          {
            path: 'setNdrcPrice',
            name: '挂牌价设置',
            component: () => import('@/view/gas/setNdrcPrice.vue')
          },
          {
            path: 'stationCollect',
            name: '站点收集',
            component: () => import('@/view/station/stationCollect.vue')
          },
          {
            path: 'lowPriceDuplicateStations',
            name: '低价重复站点',
            component: () => import('@/view/gas/lowPriceDuplicateStations.vue')
          }
        ],
      },
      {
        path: '/fleet',
        name: '车队管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'lists',
            name: '车队列表',
            component: () => import('@/view/fleet/lists.vue')
          },
          {
            path: 'companyStation',
            name: '车队定时改价',
            component: () => import('@/view/fleet/setPrice.vue')
          },
          {
            path: 'stationManage',
            name: '车队站点管理',
            component: () => import('@/view/fleet/stationManage.vue')
          },
          {
            path: 'card',
            name: '车队车辆',
            component: () => import('@/view/fleet/card.vue')
          },
          {
            path: 'zhongqi',
            name: '顺途',
            component: () => import('@/view/zhongqi/list.vue')
          },
          {
            path: 'uet',
            name: 'UET',
            component: () => import('@/view/zhongqi/uet.vue')
          },
        ],
      },
      {
        path: '/order',
        name: '订单管理',
        component:{render: (e) => e("router-view")},
        meta:{showAlways:true},
        children:[
          /*{
            path: 'private',
            name: '散户订单',
            component: () => import('@/view/order/lists.vue')
          },*/
          /*{
            path: 'waitPay',
            name: '待支付订单',
            component: () => import('@/view/order/waitPay.vue')
          },*/
          {
            path: 'companyOrder',
            name: '车队订单',
            component: () => import('@/view/order/companyOrder.vue')
          },
          {
            path: 'huituoOrder',
            name: '安能订单',
            component: () => import('@/view/order/huituoOrder.vue')
          },
          {
            path: 'feedback',
            name: '订单评价',
            component: () => import('@/view/feedback/index.vue')
          },
          {
            path: 'xindianOrder',
            name: '充电订单',
            component: () => import('@/view/order/chargingOrderList.vue')
          },
          {
            path: 'shellOrder',
            name: '壳牌虚拟卡订单',
            component: () => import('@/view/order/shellOrderLists.vue')
          },
          /*{
            path: 'promoteCount',
            name: '推广统计',
            component: () => import('@/view/promote/count.vue')
          },*/
          /*{
            path: 'private',
            name: '私油订单',
            component: () => import('@/view/order/lists2.vue')
          },*/
          /*{
            path: 'csh',
            name: '车生活订单',
            component: () => import('@/view/order/csh.vue')
          },*/
        ],
      },
      {
        path: '/operation',
        name: '运营管理',
        component: {render: (e) => e("router-view")},
        children: [
          // {
          //   path: 'qpcard',
          //   name: '壳牌卡',
          //   component: () => import('@/view/qpcard/index.vue')
          // },
          {
            path: 'shellCard',
            name: '壳牌虚拟卡',
            component: () => import('@/view/shell-card/lists.vue')
          },
          {
            path: 'sys',
            name: '系统配置',
            component: () => import('@/view/config/edit.vue')
          },
          {
            path: 'advert',
            name: '首页广告',
            component: () => import('@/view/advert/lists.vue')
          },
          {
            path: 'adminUser',
            name: '后台用户',
            component: () => import('@/view/system/user/user-lists.vue')
          },
          {
            path: 'lottery',
            name: '抽奖设置',
            component: () => import('@/view/lottery/item.vue')
          },
          {
            path: 'manual',
            name: '司机端手册配置',
            component: () => import('@/view/manual/list.vue')
          },
          {
            path: 'manual',
            name: '管理端手册配置',
            component: () => import('@/view/manual/index.vue')
          },
          /*{
            path: 'oilPrice',
            name: '油价设置',
            component: () => import('@/view/tuanyou/setPrice.vue')
          },*/
        ]
      },
      {
        path: '/finance',
        name: '财务管理',
        component: {render: (e) => e("router-view")},
        children: [
          {
            path: 'balance',
            name: '渠道充值',
            component: () => import('@/view/finance/balance.vue')
          },
          {
            path: 'siteBalance',
            name: '站点充值',
            component: () => import('@/view/finance/siteBalance.vue')
          },
          // {
          //   path: 'minshengNotice',
          //   name: '民生银行通知',
          //   component: () => import('@/view/finance/minshengNotice.vue')
          // },
        ]
      },

    ],
    //财务
    caiwuRoute=[
      {
        path: '/fleet',
        name: '车队管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'lists',
            name: '车队列表',
            component: () => import('@/view/fleet/lists.vue')
          },
          // {
          //   path: 'companyStation',
          //   name: '车队定时改价',
          //   component: () => import('@/view/fleet/setPrice.vue')
          // },
          // {
          //   path: 'card',
          //   name: '车队车辆',
          //   component: () => import('@/view/fleet/card.vue')
          // },
          {
            path: 'zhongqi',
            name: '顺途',
            component: () => import('@/view/zhongqi/list.vue')
          },
          {
            path: 'uet',
            name: 'UET',
            component: () => import('@/view/zhongqi/uet.vue')
          },
        ],
      },
      {
        path: '/order',
        name: '订单管理',
        component:{render: (e) => e("router-view")},
        meta:{showAlways:true},
        children:[
          /*{
            path: 'private',
            name: '散户订单',
            component: () => import('@/view/order/lists.vue')
          },*/
          /*{
            path: 'waitPay',
            name: '待支付订单',
            component: () => import('@/view/order/waitPay.vue')
          },*/
          {
            path: 'companyOrder',
            name: '车队订单',
            component: () => import('@/view/order/companyOrder.vue')
          },
          {
            path: 'huituoOrder',
            name: '安能订单',
            component: () => import('@/view/order/huituoOrder.vue')
          },
          {
            path: 'feedback',
            name: '订单评价',
            component: () => import('@/view/feedback/index.vue')
          },
          /*{
            path: 'promoteCount',
            name: '推广统计',
            component: () => import('@/view/promote/count.vue')
          },*/
          /*{
            path: 'private',
            name: '私油订单',
            component: () => import('@/view/order/lists2.vue')
          },*/
          /*{
            path: 'csh',
            name: '车生活订单',
            component: () => import('@/view/order/csh.vue')
          },*/
        ],
      },
      {
        path: '/finance',
        name: '财务管理',
        component: {render: (e) => e("router-view")},
        children: [
          /*{
            path: 'settle',
            name: '结账单',
            component: () => import('@/view/settlement/lists.vue')
          },*/
          {
            path: 'settle',
            name: '待结算订单',
            component: () => import('@/view/order/settle.vue')
          },
          {
            path: 'financeCount',
            name: '财务统计',
            component: () => import('@/view/finance/index.vue')
          },
          {
            path: 'financeCount',
            name: '站点财务统计',
            component: () => import('@/view/finance/stationCount.vue')
          },
          {
            path: 'balance',
            name: '渠道充值',
            component: () => import('@/view/finance/balance.vue')
          },
          {
            path: 'siteBalance',
            name: '站点充值',
            component: () => import('@/view/finance/siteBalance.vue')
          },
          {
            path: 'companyRechargeTotal',
            name: '车队充值汇总',
            component: () => import('@/view/finance/companyRechargeTotal.vue')
          },
          {
            path: 'verification',
            name: '车队充值核销',
            component: () => import('@/view/finance/verification.vue')
          },
          {
            path: 'xywithdraw',
            name: '小云提现',
            component: () => import('@/view/withdraw/xiaoyun.vue')
          },
          {
            path: 'balanceRebate',
            name: '返利',
            component: () => import('@/view/rebate/lists.vue')
          },
          {
            path: 'jiayouba',
            name: '驾油吧',
            component: () => import('@/view/finance/jiayouba/index.vue')
          },
          /*{
            path: 'commission',
            name: '佣金账户',
            component: () => import('@/view/asset/commission.vue')
          },
          {
            path: 'promote/record',
            name: '电话收入',
            component: () => import('@/view/promote/record.vue')
          },
          {
            path: 'promote/charge',
            name: '充值记录',
            component: () => import('@/view/promote/charge.vue')
          },
          {
            path: 'withdraw',
            name: '提现记录',
            component: () => import('@/view/withdraw')
          },*/
          /*{
            path: 'member',
            name: '会员充值',
            component: () => import('@/view/user/member.vue')
          },
          {
            path: 'asset/commission',
            name: '佣金账户',
            component: () => import('@/view/asset/commission.vue')
          },
          {
            path: 'asset/income',
            name: '私油账户',
            component: () => import('@/view/asset/income.vue')
          },
          {
            path: 'withdraw',
            name: '提现记录',
            component: () => import('@/view/withdraw')
          },
          {
            path: 'financeOrder',
            name: '财务订单',
            component: () => import('@/view/order/financeLists.vue')
          },*/
        ]
      },
      {
        path: '/operation',
        name: '运营管理',
        component: {render: (e) => e("router-view")},
        children: [
          {
            path: 'transfer',
            name: '转账管理',
            component: () => import('@/view/transfer/lists.vue')
          }
        ]

      },
      {
        path: '/supplier',
        name: '站点管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'routePlan',
            name: '线路规划',
            component: () => import('@/view/map/routePlan.vue')
          },
        ],
      },
    ],
    //车队权限页面
    companyRoute = [
      {
        path: 'driver',
        name: '司机列表',
        component: () => import('@/view/company/driver.vue')
      },
      {
        path: 'card',
        name: '司机卡',
        component: () => import('@/view/company/card.vue')
      },
      {
        path: 'leader',
        name: '车队长',
        component: () => import('@/view/company/leader.vue')
      },
      {
        path: 'order',
        name: '消费记录',
        component: () => import('@/view/company/order.vue')
      },
      {
        path: 'lists',
        name: '余额记录',
        component: () => import('@/view/company/companySn.vue')
      },
      {
        path: 'carNumber',
        name: '车牌管理',
        component: () => import('@/view/company/carNumber/lists.vue')
      },
      {
        path: 'obd',
        name: 'OBD信息',
        // href: 'http://team.xyobd.com/kst/#/login?mobile=15928961336&password=wb201318&intoType=KST',
        href: 'http://team.xyobd.com/largeScreen/#/',
        component: {render: (e) => e("router-view")},
      },
      {
        path: 'sonAccount',
        name: '系统账号',
        component: () => import('@/view/account/lists.vue')
      },
      {
        path: 'routePlan',
        name: '线路规划',
        component: () => import('@/view/map/routePlan.vue')
      },
    //    {
    //     path: 'document',
    //     name: '操作手册',
    //         meta: {
    //   hideInMenu: true,
    // },
    //     component: () => import('@/view/company/document.vue')

    //   },
    ],
    //子账号权限
    admin2Route = [
      {
        path: '/order',
        name: '订单管理',
        component:{render: (e) => e("router-view")},
        meta:{showAlways:true},
        children:[
          {
            path: 'private',
            name: '散户订单',
            component: () => import('@/view/order/viewLists.vue')
          },
        ],
      },
      {
        path: '/supplier',
        name: '站点管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'routePlan',
            name: '线路规划',
            component: () => import('@/view/map/routePlan.vue')
          },
        ],
      },
    ],
    //合伙人权限
    agentRoute = [
      {
        path: 'dashboard',
        name: '工作台',
        component: () => import('@/view/home/index.vue')
      },
      {
        path: 'lists',
        name: '车队列表',
        component: () => import('@/view/fleet/index.vue')
      },
      {
        path: 'card',
        name: '车队车辆',
        component: () => import('@/view/fleet/card.vue')
      },
      {
        path: 'companyOrderForAgent',
        name: '车队订单',
        component: () => import('@/view/order/companyOrderForAgent.vue')
      },
      {
        path: 'stationList',
        name: '站点列表',
        component: () => import('@/view/agent/stationList.vue')
      },
      {
        path: 'routePlan',
        name: '线路规划',
        component: () => import('@/view/map/routePlan.vue')
      },

    ],
    xianluRoute=[
      {
        path: '/supplier',
        name: '站点管理',
        component: {render: (e) => e("router-view")},
        children:[
          {
            path: 'private',
            name: '柴油站点',
            component: () => import('@/view/gas/oilStation.vue')
          },
          {
            path: 'routePlan',
            name: '线路规划',
            component: () => import('@/view/map/routePlan.vue')
          }
        ],
      },
    ],
  otherPlatRoute = [
    {
      path: '/myStation',
      name: '我的站点',
      component: () => import('@/view/otherPlat/station.vue'),
    },
    {
      path: '/supplier',
      name: '站点管理',
      component: {render: (e) => e("router-view")},
      children:[
        {
          path: 'routePlan',
          name: '线路规划',
          component: () => import('@/view/map/routePlan.vue')
        },
      ],
    },
  ];

  let authRoute = [];
  if (groupID === 1||groupID===2){
    authRoute = adminRoute
  }else if(groupID === 4){
    authRoute = companyRoute
  }else if(groupID === 5){
    authRoute = admin2Route
  }else if(groupID === 3){
    authRoute = agentRoute
  }else if(groupID === 6){
    authRoute = otherPlatRoute
  }else if(groupID === 7){
    //运营人员
    authRoute = yunyingRoute
  }else if(groupID === 8){
    //财务人员
    authRoute = caiwuRoute
  }
  else if(groupID === 9){
    //线路匹配
    authRoute = xianluRoute
  }
  return authRoute
}

